export const AddLandlordMutation = (email, firstName, lastName, phoneNo, nextKinName, 
    disbursementDate, kraPin, notes, propertyIds=[], nationalIdNumber, nextKinPhoneNumber) => {
      const mutation = `
      mutation($file: Upload){
        addLandlord(
          email: "${email}",
          firstName:"${firstName}",
          lastName:"${lastName}",
          phoneNo:"${phoneNo}",
          disbursementDate: ${disbursementDate===null ? JSON.stringify("") : JSON.stringify(disbursementDate)},
          notes: ${JSON.stringify(notes)},
          nationalIdNumber: "${nationalIdNumber}",
          kraPin: "${kraPin}",
          nextKinName: "${nextKinName}",
          contract: $file,
          nextKinPhoneNumber: "${nextKinPhoneNumber}",
          propertyIds: ${JSON.stringify(propertyIds)}
        ){
          errorMessage
      landlord{
      id
      user{
          firstName
          lastName
          nationalIdNumber
          email
          phoneNumber
      }
      properties{
          id 
          name
      }
      notes 
      disbursementDate
      nextKinName
      nextKinPhoneNumber
      kraPin
      uploads{
          id 
          file 
          name
      }
    }
  }
      }
      `;
      return mutation;
    }

    export const UpdateLandlordMutation = (landlordId, firstName, lastName, phoneNo, email, propertyIds=[],
      nextKinName, disbursementDate, kraPin, notes, nationalIdNumber, nextKinPhoneNumber) => {
        const mutation = `
        mutation($file: Upload){
          updateLandlord(
            id: ${JSON.stringify(landlordId)},
            firstName:"${firstName}",
            lastName:"${lastName}",
            phoneNo:"${phoneNo}",
            propertyIds: ${JSON.stringify(propertyIds)},
            email: "${email}",
            disbursementDate: ${disbursementDate===null ? JSON.stringify("") : JSON.stringify(disbursementDate)},
            notes: ${JSON.stringify(notes)},
            nationalIdNumber: "${nationalIdNumber}",
            kraPin: "${kraPin}",
            nextKinName: "${nextKinName}",
            contract: $file,
            nextKinPhoneNumber: "${nextKinPhoneNumber}"
          ){
            errorMessage
        landlord{
        id
        user{
            firstName
            lastName
            nationalIdNumber
            email
            phoneNumber
        }
        properties{
            id 
            name
        }
        notes 
        disbursementDate
        nextKinName
        nextKinPhoneNumber
        kraPin
        uploads{
            id 
            file 
            name
        }
      }
    }
        }
        `;
        return mutation;
      }

      export const DeleteLandlordMutation = (landlordId) => {
        const mutation = `
        mutation{
          deleteLandlord(id: ${JSON.stringify(landlordId)}){
            errorMessage
          }
        }
        `
        return mutation
      }

      export const GetLandlordsQuery = () =>{
        const query = `
        query{
          fetchLandlords(propertyIds: []){
              id
              user{
                  firstName
                  lastName
                  nationalIdNumber
                  email
                  phoneNumber
              }
              properties{
                  id 
                  name
              }
              notes 
              disbursementDate
              nextKinName
              nextKinPhoneNumber
              kraPin
              uploads{
                  id 
                  file 
                  name
              }
              
          }
      }
        `
        return query
    }